exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3FF0c{-ms-flex-pack:center;-ms-flex-align:center}._3FF0c,._3FF0c>a{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center}._3FF0c>a{-webkit-box-flex:1;-ms-flex:1 1 0%;flex:1 1 0%;-ms-flex-pack:center;-ms-flex-align:center}@media screen and (max-width:768px){._3FF0c{-ms-flex-wrap:wrap;flex-wrap:wrap}._3FF0c>a>img{width:150px}}", ""]);

// exports
exports.locals = {
	"root": "_3FF0c"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/Article/Leasing/LeasingPartners/LeasingPartners.css
// module id = 3254
// module chunks = 21